import HeroSlider from './../../../common/HeroSlider/HeroSlider';
const HeroSection = () => {
  const slides = [
    {
      title: 'Acelere o Crescimento do seu Negócio',
      description: 'Conquiste mais clientes e otimize processos com estratégias personalizadas.',
      imageUrl: '/images/homepage/hero/01.webp', // public folder or served asset
      cta: 'Fale Connosco'
    },
    {
      title: 'Ferramentas Inovadoras para PMEs',
      description: 'Simplifique a gestão, aumente a produtividade e melhore a experiência do cliente com soluções digitais.',
      imageUrl: '/images/homepage/hero/02.webp',
      cta: 'Explore Ferramentas'
    },
    {
      title: 'O Futuro do Seu Negócio Começa Hoje',
      description: 'Dê o primeiro passo para uma jornada digital bem-sucedida. Juntos, podemos alcançar grandes voos!',
      imageUrl: '/images/homepage/hero/03.webp',
      cta: 'Marque uma reunião sem compromisso'
    },
    {
      title: 'Transforme o seu Negócio',
      description: 'Apoiamos pequenas e médias empresas a dar os primeiros passos rumo ao sucesso digital',
      imageUrl: '/images/homepage/hero/04.webp',
      cta: 'Comece Já'
    }
  ];

  return (
    <section className="hero-section">
      <HeroSlider slides={slides} />
    </section>
  );
};

export default HeroSection;